import {css} from 'emotion';

const breakpoints = {
	small: 400,
	medium: 500,
	xLarge: 800,
	xxLarge: 1100,
	xxxLarge: 1280,
	tallPhone: '(max-width: 360px) and (min-height: 740px)',
};

// eslint-disable-next-line
export const queries = Object.keys(breakpoints).reduce((acc, label) => {
	const accumulator = acc;
	if (typeof breakpoints[label] === 'string') {
		accumulator[label] = (...args) =>
			css`
				@media (${breakpoints[label]}) {
					${css(...args)};
				}
			`;
	} else {
		accumulator[label] = (...args) =>
			css`
				@media (max-width: ${breakpoints[label]}px) {
					${css(...args)};
				}
			`;
	}

	return accumulator;
}, {});

export const mediaWidth = () => {
    return Object.keys(breakpoints)
        .sort((a, b) => {
            if (breakpoints[a] > breakpoints[b]) { return 1}
            if (breakpoints[a] < breakpoints[b]) { return -1}
            return 0;
        })
        .reduce(
        (acc, current) => width() > breakpoints[current] ? current : acc
    );
};

export const insideMediaWidth = (mw) => {
    const currentMediaWidth = mediaWidth();
    return breakpoints[currentMediaWidth] < breakpoints[mw];
};

export const atLeastMediaWidth = (mw) => {
    const currentMediaWidth = mediaWidth();
    return breakpoints[currentMediaWidth] >= breakpoints[mw];
};

const width = () => document.documentElement.clientWidth;





// WEBPACK FOOTER //
// ./src/styles/mediaQueries.js